import { buttonVariants } from '@/components/ui/button';
import GradualSpacing from '@/components/ui/gradual-spacing';
import { cn } from '@/utils/shadcn';
import { HTMLAttributes, ReactNode } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

interface BaseSettingsLayoutProps {
  title: string;
  sidebarNavItems: {
    title: string;
    href: string;
  }[];
  headerContent?: ReactNode;
}

export const BaseSettingsLayout = ({
  title,
  sidebarNavItems,
  headerContent,
}: BaseSettingsLayoutProps) => {
  return (
    <>
      <div className="flex md:flex-row justify-between items-end">
        <GradualSpacing
          className="font-display text-center text-3xl font-bold -tracking-widest text-black dark:text-white md:text-5xl md:leading-[4rem]"
          text={title}
        />
        {headerContent}
      </div>
      <div className="grid grid-cols-12 gap-6 min-h-0 flex-1">
        <aside className="col-span-2">
          <SidebarNav items={sidebarNavItems} />
        </aside>
        <div className="col-span-10">
          <Outlet />
        </div>
      </div>
    </>
  );
};

interface SidebarNavProps extends HTMLAttributes<HTMLElement> {
  items: {
    href: string;
    title: string;
  }[];
}

const SidebarNav = ({ className, items, ...props }: SidebarNavProps) => {
  const location = useLocation();

  return (
    <nav className={cn('flex flex-col space-y-1', className)} {...props}>
      {items.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className={cn(
            buttonVariants({ variant: 'ghost' }),
            location.pathname.includes(item.href)
              ? 'bg-muted hover:bg-muted'
              : 'hover:bg-transparent hover:underline',
            'justify-start border-0',
          )}>
          {item.title}
        </Link>
      ))}
    </nav>
  );
};
